import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { postApi } from '../../../Services/apiService';
import './../../../Auth.css';
import AuthLeftBranding from './AuthLeftBranding';
import AuthLandingFooter from './AuthLandingFooter';
import AuthBackToHome from './AuthBackToHome';
import useNoFocusZoomOnIOS from '../../../Utils/useNoFocusZoomOnIOS';

function ForgotPassword() {
    useNoFocusZoomOnIOS();
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({ email: '' });
    const [loader, setLoader] = useState(false);
    const [isEmailSent, setIsEmailSent] = useState(false);
    const navigate = useNavigate();

    const handleForgotPassword = async () => {
        if (validateForm()) {
            setLoader(true);
            
            try {
                const forgotPasswordData = {
                    email: email
                };

                const response = await postApi('/auth/forgot-password', forgotPasswordData);
                
                console.log('Forgot Password Response:', response);

                if (response?.statusCode === 200) {
                    setLoader(false);
                    setIsEmailSent(true);
                    // Toast is already shown by apiService.jsx
                    
                    // Optionally redirect to login after a few seconds
                    setTimeout(() => {
                        navigate('/login');
                    }, 3000);
                } else {
                    setLoader(false);
                    // Toast is already shown by apiService.jsx
                }

                // Clear errors on successful attempt
                setErrors({ email: '' });
            } catch (error) {
                setLoader(false);
                console.error('Forgot Password error:', error);
                // Toast is already shown by apiService.jsx
            }
        }
    };

    const validateForm = () => {
        const validationErrors = {};
        if (!email) {
            validationErrors.email = 'Email is required.';
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            validationErrors.email = 'Email is invalid.';
        }
        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    };

    return (
        <div className="login-main login-main--landing-footer">
            <div className="login-main-split login-change">
            {/* Left Side */}
            <div className="left-div">
                <AuthBackToHome placement="bluePanel" />
                <AuthLeftBranding />
            </div>

            {/* Right Side - Form */}
            <div className="login-container">
                <h2>Forgot Password</h2>
                {!isEmailSent ? (
                    <>
                        <h4>Enter your email address to receive a password reset link.</h4>

                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleForgotPassword();
                            }}
                        >
                            {/* Email */}
                            <div className="form-group email-forget">
                                <label htmlFor="email">Email Address</label>
                                <input
                                    id="email"
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    className="form-control"
                                    placeholder="Enter your email"
                                />
                                {errors.email && <div className="error">{errors.email}</div>}
                            </div>

                            <Button 
                                variant="primary" 
                                type="submit" 
                                className='login-btn' 
                                disabled={loader}
                            >
                                {loader && (
                                    <div className="spinner-border" role="status">
                                        <span className="sr-only"></span>
                                    </div>
                                )}
                                Send Reset Link
                            </Button>
                        </form>

                        <div className="signup-bottom signup-bottom--login">
                            <span>Remember your password? </span>
                            <Link to="/login" className="signup-link">
                                Back to Login
                            </Link>
                        </div>
                    </>
                ) : (
                    <div className="success-message">
                        <h4>Check Your Email</h4>
                        <p>We've sent a password reset link to <strong>{email}</strong></p>
                        <p>Please check your inbox and follow the instructions to reset your password.</p>
                        <div className="signup-bottom signup-bottom--login">
                            <Link to="/login" className="signup-link">
                                Back to Login
                            </Link>
                        </div>
                    </div>
                )}
            </div>
            </div>

            <AuthLandingFooter />
        </div>
    );
}

export default ForgotPassword;

